import { Link } from 'react-router-dom';
import './ChooseYourDesign.css';
let ChooseYourDesign =(props)=> {



    return(
        <div className='all_designs_cont'>
            <h1>Choose Your Design Of Resume</h1>
            {
                props.linkdata.map(
                    reclink=>(
                        <Link to={reclink.linkk}>
                            <div className='imgcontlink'>
                                <img className='imagechoose' src={reclink.Desimage}/> 
                            </div>  
                        </Link> 
                    )
                )
            }
          
        </div>
    );
}  

export default ChooseYourDesign;